export const C = {
  blau:     '#003366',
  blauMig:  '#002244',
  blauClar: '#dbe7fb',
  groc:     '#FFD700',
  grocClar: '#fff3c4',
  blanc:    '#ffffff',
  grisClar: '#f8f8f8',
  text:     '#1a1a2e',
  textMig:  '#4a4a6a',
  textClar: '#8888aa',
  accent:   '#0066cc',
  rosa:     '#f472b6',
  verd:     '#4ade80',
  cel:      '#60a5fa',
  shadow:   '0 4px 20px rgba(0,51,102,0.08)',
  shadowMd: '0 10px 32px rgba(0,51,102,0.12)',
  shadowLg: '0 16px 50px rgba(0,51,102,0.16)',
  radius:   '28px',
  radiusSm: '20px',
  radiusXs: '14px',
};

export const PASSWORDS    = { public:'Casalot1992', admin:'casalotAdmin123' };
export const SLIDER_IMAGES = ['foto1.png','foto2.png','foto3.png','foto4.png','foto5.png','foto6.png'];
export const SLIDER_INTERVAL = 5000;
export const SCROLL_THRESHOLD = 60;